"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var useEvent_1 = __importDefault(require("../useEvent"));
var isClient_1 = __importDefault(require("../shared/isClient"));
var getVisibility = function getVisibility() {
  if (!isClient_1["default"]) {
    return 'visible';
  }
  return document.visibilityState;
};
function useDocumentVisibility(callback) {
  var _a = (0, react_1.useState)(function () {
      return getVisibility();
    }),
    documentVisibility = _a[0],
    setDocumentVisibility = _a[1];
  var target = {
    current: document
  };
  var visibilitychange = (0, useEvent_1["default"])(target, 'visibilitychange');
  visibilitychange(function () {
    var nextDocumentVisibility = getVisibility();
    setDocumentVisibility(nextDocumentVisibility);
    callback === null || callback === void 0 ? void 0 : callback(nextDocumentVisibility);
  });
  return documentVisibility;
}
exports["default"] = useDocumentVisibility;